module.exports = __webpack_public_path__ + "img/img-155.b9d8d459.png";